import { JETTY_URL } from 'service/siwe/constants'
import { siweAuthedFetch } from 'service/siwe/siweFetch'
import { transformOrderData } from './seaportJetty'

export const addOffer = async reqBody => {
  const reqBodyTransformed = transformOrderData(reqBody)

  try {
    const req = siweAuthedFetch(`${JETTY_URL}/offers`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reqBodyTransformed)
    })
    const res = await req.then(res => res)
    return res
  } catch (err) {
    throw new Error(err)
  }
}
